import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { softseeUpdatesPageQuery, softseeUpdatesTableQuery, type SoftseeDoor } from '../api/devices'
import { toast } from '../ui/notify'
import { Spinner } from '../ui/Spinner'
import { postKitForm } from './softseeKitForm'
import { SoftseeHtmlTable } from './SoftseeHtmlTable'
import type { ScreenProps } from './screens'

/**
 * Fila Update Applications - updateApplications.php si
 * UpdateApplicationsModel. Update scrie INS/KIT. Auto Update n-are metoda in CI3.
 */

const HEADS = ['Name', 'Kit Version', 'Version', 'Action', 'Auto Update']

export function DeviceSoftseeUpdates(props: ScreenProps) {
  return <UpdatesPane {...props} door="softsee" />
}

export function DeviceOpteemumUpdates(props: ScreenProps) {
  return <UpdatesPane {...props} door="opteemum" />
}

function UpdatesPane({ id, door }: ScreenProps & { door: SoftseeDoor }) {
  const query = useQueryClient()
  const page = useQuery(softseeUpdatesPageQuery(id, door))
  const [search, setSearch] = useState('')
  const [start, setStart] = useState(0)
  const [length, setLength] = useState(10)

  const table = useQuery({
    ...softseeUpdatesTableQuery(id, door, { start, length, search }),
    placeholderData: keepPreviousData,
    enabled: !!page.data,
  })

  if (page.error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {page.error.message}
      </div>
    )
  }
  if (!page.data) return <Spinner />

  return (
    <div className="device-softsee-updates">
      <div className="row">
        <div className="col-md-12">
          <SoftseeHtmlTable
            id="deviceSoftseeUpdates"
            tableClass="update-table"
            heads={HEADS}
            rows={table.data?.data ?? []}
            total={table.data?.recordsFiltered ?? 0}
            fetching={table.isFetching}
            error={table.isError ? (table.error as Error).message : null}
            search={search}
            start={start}
            length={length}
            onSearch={(q) => {
              setSearch(q)
              setStart(0)
            }}
            onStart={setStart}
            onLength={(n) => {
              setLength(n)
              setStart(0)
            }}
            onFormSubmit={async (form) => {
              if (form.classList.contains('autoUpdateKit')) return
              if (!confirm('Are you sure?')) return
              try {
                const message = await postKitForm(form, id, door)
                toast(message, 'Success', 'success')
                await query.invalidateQueries({ queryKey: ['device', id, `${door}-updates`] })
              } catch {
                toast('Something went wrong.', 'Error', 'error')
              }
            }}
          />
        </div>
      </div>
    </div>
  )
}
